import { render } from "./Charts.vue?vue&type=template&id=61644187"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/SoilAnalysis/Partials/Charts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61644187"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61644187', __exports__)) {
    console.log('reload')
    api.reload('61644187', __exports__)
  }
  
  module.hot.accept("./Charts.vue?vue&type=template&id=61644187", () => {
    console.log('re-render')
    api.rerender('61644187', render)
  })

}


export default __exports__